<app-alert-dialog
    title="Are you sure you want to delete?"
    i18n-title="@@areYouSureDelete"
    contentTitle="Warning!"
    i18n-contentTitle="@@warning"
    contentBody="You are about to delete attached resources. Please use caution and make sure that you really intend to delete before confirming delete below."
    i18n-contentBody
>
</app-alert-dialog>
